import flatpickr from 'flatpickr';
import { Russian } from 'flatpickr/dist/esm/l10n/ru';

(function ($) {
    'use strict';

    flatpickr.localize(Russian);

    // ─── Мобильный кастомный календарь (bottom-sheet) ─────────────────────────
    var mobileCal = (function () {
        var container = null;
        var bodyEl    = null;
        var startDate = null;
        var endDate   = null;

        var MONTHS = ['Январь','Февраль','Март','Апрель','Май','Июнь',
                      'Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
        var DAYS   = ['Пн','Вт','Ср','Чт','Пт','Сб','Вс'];

        function fmt(d) {
            return d.getFullYear() + '-' +
                String(d.getMonth() + 1).padStart(2, '0') + '-' +
                String(d.getDate()).padStart(2, '0');
        }

        function toDate(str) {
            var p = str.split('-');
            return new Date(+p[0], +p[1] - 1, +p[2]);
        }

        function sameDay(a, b) {
            return a && b && fmt(a) === fmt(b);
        }

        function startOfDay(d) {
            return new Date(d.getFullYear(), d.getMonth(), d.getDate());
        }
        
        function getDateInput() {
            return document.querySelector('#countryForm .date-range-country') ||
                document.querySelector('#FlatSearchForm .date-range') ||
                document.querySelector('.date-range-country') ||
                document.querySelector('.date-range');
        }

        function getDateLabel() {
            return document.querySelector('[data-date-value]') ||
                document.querySelector('[data-ui-date-value]');
        }

        function getDateForm() {
            var input = getDateInput();

            if (!input) {
                return null;
            }

            return input.closest('form');
        }

        function render() {
            if (!bodyEl) { return; }
            var today = startOfDay(new Date());
            var html  = '';

            for (var i = 0; i < 12; i++) {
                var absMonth = today.getMonth() + i;
                var yr  = today.getFullYear() + Math.floor(absMonth / 12);
                var mo  = absMonth % 12;

                var firstDay  = new Date(yr, mo, 1);
                var daysTotal = new Date(yr, mo + 1, 0).getDate();
                var firstDow  = (firstDay.getDay() + 6) % 7; // Пн = 0

                html += '<div class="mobile-cal__month">';
                html += '<div class="mobile-cal__month-name">' + MONTHS[mo] + ' ' + yr + '</div>';
                html += '<div class="mobile-cal__weekdays">';
                DAYS.forEach(function (n) {
                    html += '<span class="mobile-cal__weekday">' + n + '</span>';
                });
                html += '</div><div class="mobile-cal__days">';

                for (var e = 0; e < firstDow; e++) {
                    html += '<div class="mobile-cal__day mobile-cal__day--empty"></div>';
                }

                for (var day = 1; day <= daysTotal; day++) {
                    var dt    = new Date(yr, mo, day);
                    var dtStr = fmt(dt);

                    var isPast       = dt < today;
                    var isStart      = !isPast && sameDay(dt, startDate);
                    var isEnd        = !isPast && sameDay(dt, endDate);
                    var inRange      = !isPast && startDate && endDate &&
                                       dt > startDate && dt < endDate;
                    var isRangeStart = isStart && endDate;
                    var isRangeEnd   = isEnd   && startDate;

                    var cls = 'mobile-cal__day';
                    if (isPast)        { cls += ' is-past'; }
                    if (isStart)       { cls += ' is-start'; }
                    if (isEnd)         { cls += ' is-end'; }
                    if (inRange)       { cls += ' is-in-range'; }
                    if (isRangeStart)  { cls += ' is-range-start'; }
                    if (isRangeEnd)    { cls += ' is-range-end'; }

                    html += '<div class="' + cls + '"' +
                        (!isPast ? ' data-cal-date="' + dtStr + '"' : '') +
                        '><span>' + day + '</span></div>';
                }

                html += '</div></div>';
            }

            bodyEl.innerHTML = html;

            bodyEl.querySelectorAll('[data-cal-date]').forEach(function (el) {
                el.addEventListener('click', function (evt) {
                    // Останавливаем всплытие: render() перезаписывает DOM до того,
                    // как событие доходит до document — detached-элемент не проходит
                    // проверку closest('.mobile-cal') и вызывает лишний closePanels()
                    evt.stopPropagation();
                    onDayClick(toDate(el.getAttribute('data-cal-date')));
                });
            });
        }

        function onDayClick(date) {
            date = startOfDay(date);
            if (!startDate || endDate || date < startDate) {
                startDate = date;
                endDate   = null;
            } else if (sameDay(date, startDate)) {
                startDate = null;
                endDate   = null;
            } else {
                endDate = date;
            }
            // Синхронизируем input после любого изменения выбора
            syncInput();
            render();
        }

        function syncInput() {
            var inp  = document.querySelector('.date-range-country');
            var lbl  = document.querySelector('[data-date-value]');
            var opts = { day: 'numeric', month: 'short' };

            if (!startDate) {
                if (inp) { inp.value = ''; }
                    if (lbl) { lbl.textContent = 'Выберите дату заезда'; }
                return;
            }

            if (!endDate) {
                if (inp) { inp.value = fmt(startDate); }
                    if (lbl) {
                        lbl.textContent = startDate.toLocaleDateString('ru-RU', opts) + ' — ...';
                    }
                 return;
                }

            if (inp) { inp.value = fmt(startDate) + ' — ' + fmt(endDate); }

                if (lbl) {
                    lbl.textContent =
                    startDate.toLocaleDateString('ru-RU', opts) + ' — ' +
                endDate.toLocaleDateString('ru-RU', opts);
                }
            }

        function open() {
            if (!container) { return; }
            render();
            container.classList.add('is-open');
            document.body.classList.add('mobile-cal-open');
        }

        function close() {
            if (!container) { return; }
            container.classList.remove('is-open');
            document.body.classList.remove('mobile-cal-open');
        }

        function init() {
            container = document.getElementById('mobileCal');
            if (!container) { return; }
            bodyEl = document.getElementById('mobileCalBody');

            container.querySelector('.mobile-cal__backdrop')
                .addEventListener('click', close);
            container.querySelector('.mobile-cal__close')
                .addEventListener('click', close);

            var clearBtn = document.getElementById('mobileCalClear');
            if (clearBtn) {
                clearBtn.addEventListener('click', function () {
                    startDate = null;
                    endDate   = null;
                    syncInput();
                    render();
                });
            }

            var applyBtn = document.getElementById('mobileCalApply');
            if (applyBtn) {
                applyBtn.addEventListener('click', function () {
                    syncInput();
                    close();
                });
            }
        }

        return { init: init, open: open, close: close };
    })();
    // ──────────────────────────────────────────────────────────────────────────

    function getShowMonths() {
        return window.innerWidth <= 768 ? 1 : 2;
    }

    function initFlatpickrForCountry() {
        if (window.innerWidth <= 768) {
            // На мобильных flatpickr не нужен — уничтожаем если остался
            document.querySelectorAll('.date-range-country').forEach(function (input) {
                if (input._flatpickr) { input._flatpickr.destroy(); }
            });
            return;
        }

        var positionElement = document.querySelector('[data-open-panel="dates"]') || undefined;
        var dateValueEl = document.querySelector('[data-date-value]');

        document.querySelectorAll('.date-range-country').forEach(function (input) {
            if (input._flatpickr) {
                input._flatpickr.destroy();
            }

            flatpickr(input, {
                mode: 'range',
                dateFormat: 'Y-m-d',
                minDate: 'today',
                showMonths: getShowMonths(),
                position: 'below left',
                positionElement: positionElement,
                enableDaysInPrevAndNextMonths: true,
                onChange: function(selectedDates, dateStr, instance) {
                    if (selectedDates.length === 2 && dateValueEl) {
                        // Форматируем даты для отображения
                        var options = { day: 'numeric', month: 'short' };
                        var startDate = selectedDates[0].toLocaleDateString('ru-RU', options);
                        var endDate = selectedDates[1].toLocaleDateString('ru-RU', options);
                        dateValueEl.textContent = startDate + ' — ' + endDate;
                    } else if (selectedDates.length === 1 && dateValueEl) {
                        var options = { day: 'numeric', month: 'short' };
                        dateValueEl.textContent = selectedDates[0].toLocaleDateString('ru-RU', options) + ' — ...';
                    }
                },
                onClose: function(selectedDates, dateStr, instance) {
                    if (selectedDates.length === 2) {
                        // Закрываем панель после выбора обеих дат
                        var bar = document.querySelector('[data-country-filter-bar]');
                        var fields = document.querySelectorAll('.country-filter__field');
                        var panels = document.querySelectorAll('.country-filter__panel');
                        
                        panels.forEach(function(p) { p.classList.remove('is-open'); });
                        fields.forEach(function(f) { f.classList.remove('is-active'); });
                        if (bar) {
                            bar.classList.remove('has-active');
                            bar.classList.remove('is-guests-active');
                        }
                    }
                }
            });
        });
    }

    function hideErrorAlert() {
        var alertEl = $('#errorAlert');
        if (alertEl.is(':visible')) {
            alertEl.stop(true, true).fadeOut(150);
        }
    }

    function positionErrorAlert() {
        var alertEl = document.getElementById('errorAlert');
        var bar = document.querySelector('[data-country-filter-bar]');
        var cityField = bar ? bar.querySelector('[data-open-panel="city"]') : null;

        if (!alertEl || !bar || !cityField) {
            return;
        }

        // На мобильных уведомление лежит в обычном потоке между городом и датами.
        if (window.innerWidth <= 768) {
            alertEl.style.top = '';
            alertEl.style.left = '';
            alertEl.style.width = '';
            return;
        }

        var barRect = bar.getBoundingClientRect();
        var fieldRect = cityField.getBoundingClientRect();

        alertEl.style.top = (fieldRect.bottom - barRect.top + 5) + 'px';
        alertEl.style.left = (fieldRect.left - barRect.left) + 'px';
        alertEl.style.width = Math.max(280, fieldRect.width) + 'px';
    }

    function initCountryFormSubmit() {
        var form = $('#countryForm');
        if (!form.length) {
            return;
        }

        $('#errorAlert').on('click', '[data-dismiss="alert"]', function () {
            hideErrorAlert();
        });

        window.addEventListener('resize', function () {
            if ($('#errorAlert').is(':visible')) {
                positionErrorAlert();
            }
        });

        form.off('beforeSubmit.countryFilter').on('beforeSubmit.countryFilter', function () {
            var $btn = $('#btnResult');
            var $btnText = $btn.find('.country-filter__submit-text');
            var isMobile = window.innerWidth <= 768;
            var defaultText = $btn.data('default-text') || ($btnText.length ? $btnText.text() : 'Искать');

            $btn.data('default-text', defaultText);
            if (isMobile && $btnText.length) {
                $btnText.text('Ищем подходящие варианты');
            }

            $btn.prop('disabled', true).addClass('country-filter__submit--loading');

            $.ajax({
                url: form.attr('action'),
                method: 'POST',
                data: form.serialize(),
                type: 'json',
                success: function (data) {
                    if (data && data.error) {
                        console.error(data.message);

                        $('#errorAlertMessage').text(data.message || 'Произошла ошибка при перенаправлении');
                        positionErrorAlert();
                        $('#errorAlert').fadeIn(300);

                        setTimeout(function () {
                            $('#errorAlert').fadeOut(300);
                        }, 5000);

                        $btn.prop('disabled', false).removeClass('country-filter__submit--loading');
                        if (isMobile && $btnText.length) {
                            $btnText.text(defaultText);
                        }
                        return;
                    }
                    window.location.href = data;
                },
                error: function (xhr, status, error) {
                    console.error('Ошибка AJAX:', status, error);
                    $('#errorAlertMessage').text('Произошла ошибка при отправке запроса');
                    positionErrorAlert();
                    $('#errorAlert').fadeIn(300);

                    setTimeout(function () {
                        $('#errorAlert').fadeOut(300);
                    }, 5000);

                    $btn.prop('disabled', false).removeClass('country-filter__submit--loading');
                    if (isMobile && $btnText.length) {
                        $btnText.text(defaultText);
                    }
                }
            });

            return false;
        });
    }

    function initCountryFilterUi() {
        var root = document.getElementById('countryFilter');
        if (!root || root.dataset.jsInited === '1') {
            return;
        }
        root.dataset.jsInited = '1';

        var bar = root.querySelector('[data-country-filter-bar]');
        var fields = Array.from(root.querySelectorAll('.country-filter__field'));
        var panels = Array.from(root.querySelectorAll('.country-filter__panel'));
        var openButtons = Array.from(root.querySelectorAll('[data-open-panel]'));
        var submitButton = document.getElementById('btnResult');

        var cityInput = root.querySelector('input[name$="[city_id]"]');
        var guestsInput = root.querySelector('input[name$="[guests]"]');
        var dateInput = root.querySelector('.date-range-country');

        var cityValueEl = root.querySelector('[data-city-value]');
        var guestsValueEl = root.querySelector('[data-guests-value]');
        var dateValueEl = root.querySelector('[data-date-value]');
        var citySearch = root.querySelector('[data-city-search]');

        function positionPanel(name, panel, field) {
            if (!panel || !field || !bar) {
                return;
            }

            panel.style.top = '';
            panel.style.left = '';
            panel.style.width = '';

            if (window.innerWidth <= 768) {
                var rootRect = root.getBoundingClientRect();
                var mobileFieldRect = field.getBoundingClientRect();

                panel.style.top = Math.max(0, mobileFieldRect.bottom - rootRect.top) + 'px';
                panel.style.left = Math.max(0, mobileFieldRect.left - rootRect.left) + 'px';
                panel.style.width = Math.max(280, mobileFieldRect.width) + 'px';
                return;
            }

            if (name === 'dates') {
                panel.style.left = '0px';
                panel.style.width = '100%';
                return;
            }

            var barRect = bar.getBoundingClientRect();
            var fieldRect = field.getBoundingClientRect();
            var left = fieldRect.left - barRect.left;
            var width = fieldRect.width;

            if (name === 'guests' && submitButton) {
                var submitRect = submitButton.getBoundingClientRect();
                width = (submitRect.right - fieldRect.left);
            }

            panel.style.left = Math.max(0, left) + 'px';
            panel.style.width = Math.max(320, width) + 'px';
        }

        function setExpanded(expanded) {
            if (!submitButton) {
                return;
            }
            submitButton.classList.toggle('is-expanded', expanded);
        }

        function closePanels() {
            panels.forEach(function (p) {
                p.classList.remove('is-open');
            });
            fields.forEach(function (f) {
                f.classList.remove('is-active');
            });

            if (dateInput && dateInput._flatpickr) {
                dateInput._flatpickr.close();
            }

            if (bar) {
                bar.classList.remove('has-active');
                bar.classList.remove('is-guests-active');
            }

            mobileCal.close();
            setExpanded(false);
        }

        function openPanel(name) {
            var panel = root.querySelector('[data-panel="' + name + '"]');
            var field = root.querySelector('[data-open-panel="' + name + '"]');
            if (!field) {
                return;
            }

            closePanels();

            if (name === 'city') {
                hideErrorAlert();
            }

            // На мобильных открываем кастомный календарь вместо flatpickr
            if (name === 'dates' && window.innerWidth <= 768) {
                mobileCal.open();
                return;
            }

            if (panel && name !== 'dates') {
                positionPanel(name, panel, field);
                panel.classList.add('is-open');
            }

            field.classList.add('is-active');
            if (bar) {
                if (name === 'guests') {
                    bar.classList.add('is-guests-active');
                }
                bar.classList.add('has-active');
            }

            setExpanded(true);

            if (name === 'city' && citySearch) {
                citySearch.focus();
            }
            if (name === 'dates' && dateInput && dateInput._flatpickr) {
                dateInput._flatpickr.open();
            }
        }

        window.addEventListener('resize', function () {
            var opened = root.querySelector('.country-filter__panel.is-open');
            var activeField = root.querySelector('.country-filter__field.is-active');
            if (!opened || !activeField) {
                initFlatpickrForCountry();
                return;
            }

            var name = opened.getAttribute('data-panel');
            positionPanel(name, opened, activeField);
            initFlatpickrForCountry();
        });

        openButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var panelName = btn.getAttribute('data-open-panel');
                if (btn.classList.contains('is-active')) {
                    closePanels();
                    return;
                }

                openPanel(panelName);
            });
        });

        root.querySelectorAll('[data-city-id]').forEach(function (option) {
            option.addEventListener('click', function () {
                if (cityInput) {
                    cityInput.value = option.getAttribute('data-city-id');
                }
                if (cityValueEl) {
                    cityValueEl.textContent = option.getAttribute('data-city-name');
                }
                closePanels();
            });
        });

        root.querySelectorAll('[data-guests]').forEach(function (option) {
            option.addEventListener('click', function () {
                if (guestsInput) {
                    guestsInput.value = option.getAttribute('data-guests');
                }
                if (guestsValueEl) {
                    guestsValueEl.textContent = option.getAttribute('data-guests-label');
                }
                closePanels();
            });
        });

        if (citySearch) {
            citySearch.addEventListener('input', function () {
                var query = citySearch.value.toLowerCase().trim();
                root.querySelectorAll('[data-city-id]').forEach(function (option) {
                    var name = (option.getAttribute('data-city-name') || '').toLowerCase();
                    option.style.display = (!query || name.indexOf(query) !== -1) ? '' : 'none';
                });
            });
        }

        if (dateInput) {
            dateInput.addEventListener('change', function () {
                var value = (dateInput.value || '').trim();
                if (dateValueEl && !value) {
                    dateValueEl.textContent = 'Выберите дату заезда';
                }
                // Не закрываем панель здесь - это делается в onClose flatpickr
            });
        }

        document.addEventListener('click', function (event) {
            // Игнорируем клики по календарю Flatpickr
            if (event.target.closest('.flatpickr-calendar')) {
                return;
            }
            // Игнорируем клики внутри мобильного календаря
            if (event.target.closest('.mobile-cal')) {
                return;
            }
            if (!root.contains(event.target)) {
                closePanels();
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closePanels();
            }
        });
    }

    function initCountryFilter() {
        mobileCal.init();
        initCountryFormSubmit();
        initCountryFilterUi();
        initFlatpickrForCountry();
    }

    $(initCountryFilter);
})(jQuery);
